// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import { USER_ROLES } from "../../staticData/userRoles";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { SET_UNREAD_NOTIFICATIONS_COUNT } from "../constants/notifications";

export const updateNotificationStatusAction = ({
  notificationIds,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    // Backend accepts a JSON body of `{ notificationIds: [...] }` to mark
    // specific notifications, or `{}` to mark all unread of the user as read.
    // Sending no body at all triggers a 500 (it reads `body.notificationIds`).
    const data = Array.isArray(notificationIds) ? { notificationIds } : {};

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateNotificationStatus`,
      isToken: true,
      data
    });

    if (response) {
      if (successCallback) {
        successCallback({
          response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

const fetchUnreadNotificationsCount = () => {
  return async (dispatch, getState) => {
    const { response, error } = await apiRequest({
      url: isActiveRole(USER_ROLES.FREELANCE_EC)
        ? "getFreelanceEcNotifications"
        : "getNotifications",
      params: {
        getNotificationCount: true
      },
      isToken: true
    });

    if (response) {
      //
      dispatch({
        type: SET_UNREAD_NOTIFICATIONS_COUNT,
        payload: {
          unreadNotificationsCount: response?.data?.data?.unreadCount
        }
      });
    } else {
      //
    }
  };
};

//getOneOnOneNotesOfAssignee(create notification api)

export const fetchOneOnOneNotesOfAssignee = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_REQUEST" });

    const { response, error } = await apiRequest({
      method: "GET",
      url: "getOneOnOneNotesOfAssignee",
      params: payload?.params,
      isToken: true
    });

    if (response?.status === 200) {
      dispatch({
        type: "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_SUCCESS",
        payload: response.data
      });
      if (successCallback) successCallback(response.data);
    } else {
      dispatch({
        type: "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_FAILURE",
        payload:
          error?.message || "Failed to fetch event one on one notes of assignee"
      });
      if (failureCallback) failureCallback(error);
    }
  };
};

export const updateNotesStatusAction = ({ status }) => {
  return { type: "UPDATE_NOTE_STATUS", payload: status };
};

export { fetchUnreadNotificationsCount };